
(function documentContainerDocumentsControllerDefinition() {
    'use strict';

    angular.module('DocumentContainer')
        .controller('DocumentContainerAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'documentContainerService',
            'authExtend', 'containerTypeService',
            'fileService', 'documentTypeService', 'twainCapture',
            function documentContainerDocumentsAdd($scope, config, $state, $translate, errors, $stateParams, documentContainerService, authExtend, containerTypeService,
                fileService, documentTypeService, twainCapture) {

                /* Busco si ya existe un archivo con el indice */
                twainCapture.setFileNameStartIndex();

                $scope.canDigitalize = authExtend.isInRole('DOCUMENT DIGITALIZATION');
                $scope.canAddItemsToComboMetadata = authExtend.isInRole('METADATA INSERT');
                $scope.hasNameTemplate = false;

                $scope.cancel = function () {
                    $state.go('document-container-find');
                };

                $scope.title = 'DocumentContainerDocumentsAdd';

                $scope.changeAsName = function (value) {
                    if (value.updatesName) {
                        $scope.aux.document.name = value.metadataValue;
                        $scope.container.name = value.metadataValue;
                    }
                };

                $scope.load = function () {
                    $scope.documentWrite = authExtend.isInRole('DOCUMENTVERSIONED WRITE') || authExtend.isInRole('DOCUMENT WRITE');

                    $scope.containerMetadataAsName = false;

                    $scope.container = {
                        name: '',
                        containerTypeId: '',
                        containerTypeName: '',
                        parents: [],
                        metadatas: [],
                        documents: [],
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName()
                    };
                    $scope.optionsContainerTypes = [];
                    $scope.optionsDocumentTypes = [];

                    $scope.preview = {
                        closed: true,
                        loading: false,
                        content: null,
                        index: null,
                        item: null,
                        invalid: false,
                        containerTab: true
                    };

                    $scope.aux = {
                        files: [],
                        filesTemp: [],
                        document: {
                            selectedDocumentTypeId: null
                        },
                        metadataAsName: 0
                    };


                    containerTypeService.getFunctionsTypes(['DOCUMENTCONTAINER WRITE']).then(function (result) {
                        $scope.optionsContainerTypes = result.sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                        });

                        if ($scope.optionsContainerTypes.length === 1) {
                            $scope.selectContainerType($scope.optionsContainerTypes[0]);
                            $scope.container.containerTypeId = $scope.optionsContainerTypes[0].id;
                        }
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.removeFile = function (file) {
                    var index = $scope.getIndexFile(file);

                    if (~index) {
                        if ($scope.preview.index == index) {
                            $scope.hidePreview();
                        }
                        $scope.aux.files.splice(index, 1);
                        $scope.container.documents.splice(index, 1);
                    }
                };

                $scope.previewFile = function (item, index) {
                    $scope.preview.content = null;
                    $scope.preview.loading = true;
                    $scope.preview.closed = false;
                    $scope.preview.invalid = false;

                    fileService.preview($scope.aux.files[index], true).then(function (result) {

                        $scope.preview.content = result;

                        $scope.preview.item = item;
                        $scope.preview.index = index;
                        $scope.preview.loading = false;
                    }, function (error) {
                        if (error.data && error.data.modelState && error.data.modelState.no_converter) {
                            $scope.preview.loading = false;
                            $scope.preview.invalid = true;
                            $scope.preview.item = item;
                            $scope.preview.index = index;
                        }
                        else {
                            errors.showError(error);
                            $scope.hidePreview();
                        }
                    });

                    $scope.aux.document = $scope.container.documents[index];
                    if ($scope.optionsDocumentTypes.length === 1 && $scope.aux.document.documentTypes.length === 0) {
                        $scope.aux.document.selectedDocumentTypeId = $scope.optionsDocumentTypes[0].id;
                        $scope.selectDocumentType($scope.optionsDocumentTypes[0]);
                    } else {
                        if ($scope.aux.document.documentTypes.length === 1) {
                            $scope.aux.document.selectedDocumentTypeId = $scope.aux.document.documentTypes[0].documentTypeId;
                        }
                    }
                };

                $scope.hidePreview = function () {
                    $scope.aux.document.isValid = $scope.documentsForm.$valid;
                    if (!$scope.aux.document.isValid) {
                        $scope.documentsForm.$setSubmitted();
                    }

                    $scope.preview.closed = true;
                    $scope.preview.loading = false;
                    $scope.preview.content = null;
                    $scope.preview.index = null;
                    $scope.preview.invalid = false;
                    $scope.preview.item = null;
                };

                $scope.ready = function () {
                    $scope.hidePreview();
                };

                $scope.nextPreview = function () {
                    $scope.aux.document.isValid = $scope.documentsForm.$valid;
                    if (!$scope.aux.document.isValid) {
                        $scope.documentsForm.$setSubmitted();
                    }

                    if ($scope.preview.index + 1 < $scope.aux.files.length) {
                        $scope.preview.index++;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);

                    }
                };

                $scope.prevPreview = function () {
                    $scope.aux.document.isValid = $scope.documentsForm.$valid;
                    if (!$scope.aux.document.isValid) {
                        $scope.documentsForm.$setSubmitted();
                    }

                    if ($scope.preview.index) {
                        $scope.preview.index--;
                        $scope.previewFile($scope.aux.files[$scope.preview.index], $scope.preview.index);
                    }
                };


                $scope.addFile = function () {
                    $scope.aux.filesTemp.forEach(function (file) {
                        if (file && file.size) {
                            file.fsize = fileService.FormatfileSize(file.size);
                            var index = $scope.getIndexFile(file);
                            if (~index) {
                                file.documntTypesNames = $scope.aux.files[index].documntTypesNames;
                                $scope.aux.files[index] = file;
                            } else {
                                file.documntTypesNames = '';
                                $scope.aux.files.push(file);

                                var document = {
                                    name: file.name,
                                    documentTypes: [],
                                    organizationalUnitId: authExtend.getOrganizationId(),
                                    metadataAsName: 0
                                }
                                $scope.container.documents.push(document);
                            }
                        }
                    });

                    $scope.aux.filesTemp = [];
                };

                $scope.getIndexFile = function (fileNew) {

                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    };

                    return -1;
                };

                $scope.getReplicatedMetadata = function (metadata) {
                    for (var i = 0; $scope.container.metadatas.length > i; i++) {
                        if ($scope.container.metadatas[i].metadataReplicate && $scope.container.metadatas[i].metadataId === metadata.metadataId) {
                            return $scope.container.metadatas[i];
                        }
                    }

                    return null;
                };

                $scope.loadDocTypeMetadata = function (documentType) {

                    var documentDocType = {
                        documentTypeName: documentType.name,
                        documentTypeId: documentType.id,
                        metadatas: []
                    };

                    $scope.aux.document.documentTypes = [];

                    if (documentType.nameTemplate) {
                        $scope.aux.document.metadataAsName++;
                    } else {
                        $scope.aux.document.metadataAsName= 0;
                    }

                    documentType.metadata.forEach(function (metadata) {

                        var replicated = $scope.getReplicatedMetadata(metadata);                        
                        var newMetadata = {
                            idObject: documentDocType.documentTypeId + '' + metadata.metadataId,
                            metadataId: metadata.metadataId,
                            metadataIsRequired: metadata.isRequired,
                            metadataIsUnique: metadata.isUnique,
                            metadataValue: '',
                            metadataType: metadata.metadataType,
                            metadataLabel: metadata.metadataLabel,
                            metadataOptions: metadata.optionValues,
                            maskOptions: metadata.maskOptions,
                            mask: metadata.metadataMask,
                            maskPlaceHolder: metadata.metadataMaskPlaceHolder,
                            metadataReadOnly: false,
                            metadataAsName: metadata.asName,
                            metadataAttributes: metadata.attributes,
                            metadataIsMultivalue: metadata.isMultivalue,
                            metadataIsUpdateable: (metadata.isUpdateable && $scope.canAddItemsToComboMetadata)
                        };

                        if (replicated) {
                            newMetadata.metadataReadOnly = true;
                            newMetadata.metadataValue = replicated.metadataValue;
                        }

                        documentDocType.metadatas.push(newMetadata);
                    });

                    $scope.aux.document.documentTypes = [];
                    $scope.aux.document.documentTypes.push(documentDocType);
                };

                $scope.loadContainerMetadata = function (type) {
                    $scope.containerMetadataAsName = false;
                    $scope.container.containerTypeName = type.name;
                    $scope.container.metadatas = [];

                    type.metadata.forEach(function (metadata) {
                        var newMetadata = {
                            idObject: type.id + '_' + metadata.metadataId,
                            metadataId: metadata.metadataId,
                            metadataIsRequired: metadata.isRequired,
                            metadataIsUnique: metadata.isUnique,
                            metadataValue: '',
                            metadataType: metadata.metadataType,
                            metadataLabel: metadata.metadataLabel,
                            metadataOptions: metadata.optionValues,
                            maskOptions: metadata.maskOptions,
                            mask: metadata.metadataMask,
                            maskPlaceHolder: metadata.metadataMaskPlaceHolder,
                            metadataReplicate: metadata.isReplicated,
                            metadataSystemName: metadata.metadataSystemName,
                            metadataAttributes: metadata.attributes,
                            metadataIsMultivalue: metadata.isMultivalue,
                            metadataIsUpdateable: (metadata.isUpdateable && $scope.canAddItemsToComboMetadata)
                        };

                        $scope.container.metadatas.push(newMetadata);

                        if (metadata.asName && !$scope.containerMetadataAsName) {
                            newMetadata.updatesName = true;
                            $scope.containerMetadataAsName = true;
                        }

                        if (newMetadata.metadataReplicate) {
                            $scope.$watch('container.metadatas[' + ($scope.container.metadatas.length - 1).toString() + '].metadataValue', function itemsChanged() {
                                $scope.replicateValues();
                            });
                        }
                    });

                };

                $scope.replicateValues = function () {
                    for (var i = 0; $scope.container.documents.length > i; i++) {
                        for (var k = 0; $scope.container.documents[i].documentTypes.length > k; k++) {
                            for (var l = 0; $scope.container.documents[i].documentTypes[k].metadatas.length > l; l++) {
                                var m = $scope.container.documents[i].documentTypes[k].metadatas[l];
                                var replicated = $scope.getReplicatedMetadata(m);
                                if (replicated) {
                                    m.metadataValue = replicated.metadataValue;
                                    m.metadataReadOnly = true;
                                    if (m.updatesName) {
                                        $scope.container.documents[i].name = replicated.metadataValue;
                                    }
                                }
                            }
                        }
                    }
                };

                $scope.selectContainerType = function (type) {
                    containerTypeService.getById(type.id, 'detail').then(function (result) {
                        $scope.hasNameTemplate = result.nameTemplate !== null;
                        $scope.loadContainerMetadata(result);
                        var containerTypes = [];
                        containerTypes.push(type.id);

                        documentTypeService.getByContainerId(containerTypes, ['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE']).then(function (result) {
                            $scope.optionsDocumentTypes = result.sort(function (a, b) {
                                return a.name.localeCompare(b.name);
                            });

                            /*
                            $scope.container.documents.forEach(function (doc) {
                                doc.documentTypes = [];
                            });
                            $scope.aux.document.selectedDocumentTypeId = null;
                            */

                        }, function (error) {
                            errors.showError(error);
                            $state.go('document-find');
                        });

                    }, function (error) {
                        errors.showError(error);
                        $state.go('document-find');
                    });
                };

                $scope.selectDocumentType = function (documentType) {
                    documentTypeService.getById(documentType.id, 'detail').then(function (result) {
                        $scope.loadDocTypeMetadata(result);
                        if ($scope.aux.files.length > $scope.preview.index) {
                            $scope.aux.files[$scope.preview.index].documntTypesNames = $scope.aux.document.documentTypes[0].documentTypeName;                        
                        }
                    }, function (error) {
                        errors.showError(error);
                        $state.go('document-find');
                    });
                };

                $scope.metadataTypeCount = function () {
                    if ($scope.container.metadatas) {
                        return $scope.container.metadatas.length;
                    }

                    return 0;
                };

                $scope.save = function (checkin) {
                    if (!$scope.documentContainerForm.$valid) {
                        $scope.documentContainerForm.$setSubmitted();
                        errors.showError('VerifyContainerFormData');
                        return false;
                    }

                    if ($scope.container.parents.length > 0) {
                        $scope.container.documentContainersParent = [];
                        $scope.container.parents.forEach(function (parent) {
                            $scope.container.documentContainersParent.push({ parentId: parent.id });
                        });
                    }

                    var hasErrors = false;
                    for (var i = 0; $scope.container.documents.length > i; i++) {
                        $scope.aux.files[i].hasError = !$scope.container.documents[i].isValid;
                        if (!$scope.container.documents[i].isValid) {
                            hasErrors = true;
                        }
                    }
                    if (hasErrors) {
                        errors.showError('ContainerDocumentVerifyFormData');
                        return false;
                    }

                    if ($scope.container.documents.length <= 0) {
                        return documentContainerService.create($scope.container, checkin).then(function () {
                            $state.go('document-container-find');
                        }, function (error) {
                            errors.showError(error);
                        });
                    } else {
                        return documentContainerService.createWithDocuments($scope.container, $scope.aux.files).then(function () {
                            $state.go('document-container-find');
                        }, function (error) {
                            if (error.data && error.data.modelState && error.data.modelState.error[1]) {
                                var index = error.data.modelState.error[1];
                                $scope.aux.files[index].hasError = true;
                            }

                            errors.showError(error);
                        });
                    }
                };

                $scope.beginDigitalization = function () {
                    $scope.digitalizerOpen = true;
                };

                $scope.cancelDigitalization = function () {
                    $scope.digitalizerOpen = false;
                };

                $scope.scanning = false;
                $scope.hasScannedDocument = false;

                $scope.digitalize = function () {

                    $scope.scanning = true;

                    var callback = function () {
                        twainCapture.scanOne()
                            .then(function (index) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            }, function (error) {
                                $scope.scanning = false;
                                $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                                errors.showError(error);
                            });
                    };

                    twainCapture.deleteFirstImage().then(callback, callback);
                };

                $scope.addDigitalized = function () {

                    /* Busco si ya existe un archivo con el indice */
                    var fileName = twainCapture.findUniqueName($scope.aux.files.concat($scope.aux.filesTemp));

                    twainCapture.popImageFile(fileName)
                        .then(function (file) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            $scope.aux.filesTemp.push(file);
                            $scope.addFile();
                        }, function (error) {
                            $scope.hasScannedDocument = (twainCapture.imagesCount() !== 0);
                            errors.showError(error);
                        });
                };

                $scope.configureDigitalization = function () {
                    twainCapture.showConfigUi();
                };

                $scope.$watch(function () {
                    return twainCapture.isAvailable();
                }, function (val) {
                    $scope.digitalizerNotAvaliable = !val;
                });

                $scope.load();

            }]);
})();